export default {
  en: {
    CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TARGETS: 'Targets',
    CAMPAIGN_STEP_ROUTING_SELECTED_TABS_GROUPS: 'Groups',
    CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TREES: 'Trees',
    CAMPAIGN_STEP_ROUTING_TARGETS_SEARCH: 'Search',
    CAMPAIGN_STEP_ROUTING_TARGETS_NEW: 'New',
    CALL_PLANS_REFRESH_TARGETS: 'Refresh Targets',
    


    CAMPAIGN_STEP_ROUTING_TARGETS_NAME: 'Name',
    CAMPAIGN_STEP_ROUTING_TARGETS_TYPE: 'Type',
    CAMPAIGN_STEP_ROUTING_TARGETS_NUMBER: 'Destination',
    CAMPAIGN_STEP_ROUTING_TARGETS_STATUS: 'Status',
    CAMPAIGN_STEP_ROUTING_TARGETS_ADD: 'Add',
    

    CONVERSION_DUPLICATE_DISABLE:'Disable',
    CONVERSION_DUPLICATE_ENABLE:'Enable',
    CONVERSION_DUPLICATE_AFTER:'Time Limit',

    TARGET_ROUTE_CONVERT: 'Convert On',
    TARGET_ROUTE_CONVERT_TT: 'A conversion will be triggered when the selected event happens.',   
    TARGET_ROUTE_DUPLICATE: 'Duplicate Conversions',
    TARGET_ROUTE_DUPLICATE_TT: 'Configure how Ringba will handle and credit duplicate conversions.',
    TARGET_ROUTE_HEADER: 'Create Target',
    TARGET_ROUTE_LENGTH: 'Length',
    TARGET_ROUTE_LENGTH_TT: 'The number of seconds required before a call is counted as a conversion.',
    TARGET_ROUTE_NAME: 'Name',
    TARGET_ROUTE_NAME_TT: 'The name of the target that will be added to your campaign.',
    TARGET_ROUTE_PRIORITY: 'Priority',
    TARGET_ROUTE_PRIORITY_TT: 'The priority that Ringba will select available targets. 1 is the highest priority.',
    TARGET_ROUTE_REVENUE: 'Revenue',
    TARGET_ROUTE_REVENUE_POSTBACK: 'Default Revenue',
    TARGET_ROUTE_REVENUE_POSTBACK_TT: 'The default amount of money generated when the webhook is received without a conversion amount.',
    TARGET_ROUTE_REVENUE_TT: 'The amount of money generated when the call is received.',
    TARGET_ROUTE_START_CONNECT: 'Connect',
    TARGET_ROUTE_START_DIAL: 'Dial',
    TARGET_ROUTE_START_EVENT: 'Start Call Length On',
    TARGET_ROUTE_START_EVENT_TT: 'The point in the call where we start the call length timer for the conversion.',
    TARGET_ROUTE_START_INCOMING: 'Incoming',
    TARGET_ROUTE_WEIGHT: 'Weight',
    TARGET_ROUTE_WEIGHT_TT: 'If you have 2 targets with the same priority, weight will be used to balance the routing between the targets. Weights are relative values. Example: 2 Targets with a weight of 10 will each receive 50% of the calls',
    TARGETS_TYPE_NUMBER: 'Number',
    TARGETS_TYPE_SIP: 'SIP',

    REQUIRED_LABEL: 'Required',

    CAMPAIGN_STEP_ROUTING_LOADING_TARGETS: 'Loading Targets.',



    CAMPAIGN_STEP_ROUTING_ALL_TARGETS_ASSIGNED: 'All the available targets have already been assigned to the routing plan.',
    CAMPAIGN_STEP_ROUTING_NONE_TARGETS: 'You have not added any targets.',

    CAMPAIGN_STEP_ROUTING_GROUPS_SEARCH: 'Search',
    CAMPAIGN_STEP_ROUTING_GROUPS_NEW: 'New',

    CAMPAIGN_STEP_ROUTING_GROUPS_NAME: 'Name',
    CAMPAIGN_STEP_ROUTING_GROUPS_SIMULDIAL: 'Simuldial',
    CAMPAIGN_STEP_ROUTING_GROUPS_TARGETS: 'Targets',
    CAMPAIGN_STEP_ROUTING_GROUPS_STATUS: 'Status',
    CAMPAIGN_STEP_ROUTING_GROUPS_ADD: 'Add',

    CAMPAIGN_STEP_ROUTING_ALL_TARGET_GROUPS_ASSIGNED: 'All the available target groups have already been assigned to the routing plan.',
    CAMPAIGN_STEP_ROUTING_NONE_TARGET_GROUPS: 'You have not added any target groups.',
    TARGETS_STATUS_DISABLED_GROUP: 'Target Group Disabled',
    CAMPAIGN_STEP_ROUTING_LOADING_TARGET_GROUPS: 'Loading Target Groups.',

    CAMPAIGN_STEP_ROUTING_ALL_PING_TREES_ASSIGNED: 'All the available ring trees have already been assigned to the routing plan.',
    CAMPAIGN_STEP_ROUTING_NONE_PING_TREES: 'You have not added any ring trees.',
    CAMPAIGN_STEP_ROUTING_LOADING_PING_TREES: 'Loading Ring Trees.',

    CAMPAIGN_STEP_ROUTING_SELECTED_HEADER: 'Routing Plan',

    CAMPAIGN_STEP_ROUTING_SELECTED_EDIT: 'Edit',
    CAMPAIGN_STEP_ROUTING_SELECTED_DELETE: 'Remove',
    CAMPAIGN_STEP_ROUTING_SELECTED_PRIORITY: 'Priority',
    CAMPAIGN_STEP_ROUTING_SELECTED_WEIGHT: 'Weight',
    CAMPAIGN_STEP_ROUTING_SELECTED_NAME: 'Name',
    CAMPAIGN_STEP_ROUTING_SELECTED_NUMBER: 'Destination',
    CAMPAIGN_STEP_ROUTING_SELECTED_NUMBER_DYNAMIC: 'Dynamic',
    CAMPAIGN_STEP_ROUTING_SELECTED_TYPE: 'Type',
    CAMPAIGN_STEP_ROUTING_SELECTED_REVENUE: 'Revenue',

    CAMPAIGN_STEP_ROUTING_CONVERSION_PING_TREE: 'Ring Tree',

    CAMPAIGN_STEP_ROUTING_SELECTED_DEFAULT: 'Please add at least 1 Target, Group, or Tree.',

    ROUTING_CONVERSION_CALL_INCOMING: 'On Incoming',
    ROUTING_CONVERSION_CALL_DIAL: 'On Dial',
    ROUTING_CONVERSION_CALL_CONNECT: 'On Connected',  
    
    HOURS: 'Hours',
    DAYS: 'Days',

  },
};
